import { lazy, Suspense } from 'react';
import { Skeleton } from '@/components/ui/skeleton';

/**
 * Lazy-loaded so a role that never opens the booking report never downloads
 * recharts (docs/booking-report-frontend.md §2). Kept in its own file so
 * router.tsx's Fast Refresh boundary stays just the route table.
 */
const BookingReportScreen = lazy(() =>
  import('@/screens/reports/booking/BookingReportScreen').then((module) => ({
    default: module.BookingReportScreen,
  })),
);

function BookingReportFallback() {
  return (
    <div className="flex flex-col gap-4">
      <Skeleton className="h-8 w-48" />
      <Skeleton className="h-64 w-full" />
    </div>
  );
}

export function LazyBookingReportScreen() {
  return (
    <Suspense fallback={<BookingReportFallback />}>
      <BookingReportScreen />
    </Suspense>
  );
}
